"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

/**
 * Cover photo for standard variant cards. Accepts an image url, and custom children 
 * (e.g. Avatar) displayed at the bottom of the cover photo.
 */
var CardCoverPhoto =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(CardCoverPhoto, _React$Component);

  function CardCoverPhoto() {
    (0, _classCallCheck2["default"])(this, CardCoverPhoto);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CardCoverPhoto).apply(this, arguments));
  }

  (0, _createClass2["default"])(CardCoverPhoto, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          src = _this$props.src,
          children = _this$props.children;
      return _react["default"].createElement("div", {
        className: "spectrum-Card-coverPhoto",
        style: {
          backgroundImage: "url(".concat(JSON.stringify(src), ")")
        }
      }, children);
    }
  }]);
  return CardCoverPhoto;
}(_react["default"].Component);

exports["default"] = CardCoverPhoto;
(0, _defineProperty2["default"])(CardCoverPhoto, "propTypes", {
  /** Image url to be displayed in the cover photo */
  src: _propTypes["default"].string
});